// removed by extract-text-webpack-plugin
module.exports = {"overlay":"MIwuS","container":"_2yi5R","header":"TgWkA","headerTitle":"_6ypd9","headerTitleLabel":"_3yiKZ","headerBody":"_3aYEa","previewSelection":"Ko6nm","previewSelectionItem":"_39aDp","main":"oCu7C","footer":"_2pgl_","confirm":"_39byI","clear":"_1ot-_","customHeaderDatepicker":"_12pAX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/V2/datepicker/mobile-fullscreen/styles.module.css
// module id = 225
// module chunks = 0